/**
 * Curry function that returns iterator for returning element with id as elementId
 * @param elementId id to be located
 */
export const withId = (elementId?: string) => (el: { id: string }) =>
  el.id === elementId;
